import React, { useState } from "react";
import "../styles/Signup-For-FamilyMember.css";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import Patientaddress from "./PatientAddress";
import PrivacyPolicy from "./PrivacyPolicies";
import { subscriptionStatus, USER_TYPES } from "../App";

const SignupforFamilyMember = () => {


  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const [step, setStep] = useState(0)
  const [data, setData] = useState({});
  const onsubmit = (data) => {
    setStep(1)
    setData(data)
  }

  const step2Data = (values) => {
    setStep(2)
    setData(values)
  }

  // document.addEventListener('keydown', (event) => {
  //   if (event.keyCode === 13) {
  //     event.preventDefault();
  //     console.log('Enter key pressed');
  //     handleSubmit(onsubmit)();
  //   }
  // });

  return (
    <div>
      {
        step === 0 && <>

          <form className="Signupfamilymember-container" onSubmit={handleSubmit((onsubmit))}>

            <h1>Youro</h1>
            <p className="h3">Membership/Sign-up gives you direct access to our team of<br /> urological providers with same or next day appointments.  </p>
            <div className="Form-Container">
              <div className="name-fields">
                <div className="label-input">
                  <label>Family Member First Name</label>
                  <input className="input-field input-border" type="text" {...register("firstName", {
                    required: true,
                    maxLength: 32,
                  })} />
                  {errors?.firstName?.type === "required" && <p className="error-text">This field is required</p>}
                  {errors?.firstName?.type === "maxLength" && <p className="error-text">First name cannot exceed 32 characters</p>}
                </div>

                <div className="label-input">
                  <label>Family Member Last Name</label>
                  <input className="input-field input-border" type="text" {...register("lastName", {
                    required: true,
                    maxLength: 32,
                  })} />
                  {errors?.lastName?.type === "required" && <p className="error-text">This field is required</p>}
                  {errors?.lastName?.type === "maxLength" && <p className="error-text">Last Name cannot exceed 32 characters</p>}
                </div>
              </div>

              <div className="name-fields">
                <div className="label-input">
                  <label>Email (Family Member)</label>
                  <input className="input-field input-border" type="text" {...register("email", {
                    required: true,
                    maxLength: 32,
                    pattern: /([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+/
                  })} />
                  {errors?.email?.type === "required" && <p className="error-text">This field is required</p>}
                  {errors?.email?.type === "maxLength" && <p className="error-text">Email cannot exceed 32 characters</p>}
                  {errors?.email?.type === "pattern" && <p className="error-text">Please enter valid email</p>}
                </div>


                <div className="label-input">
                  <label>Phone Number (Family Member)</label>
                  <input
                    type="tel"
                    className="input-field input-border"
                    id="phoneNumber"
                    {...register("phoneNumber", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter a valid 10-digit phone number"
                      }
                    })}
                  />
                  {errors?.phoneNumber && <p className="error-text">{errors.phoneNumber.message}</p>}
                </div>
              </div>

              <div className="name-fields">
                <div className="label-input" style={{ width: '35%' }}>
                  <label>Email (User who is registering)</label><br />
                  <input className="input-field input-border" style={{ width: "95%" }} type="text" {...register("relationEmail", {
                    required: true,
                    maxLength: 32,
                    pattern: /([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+/
                  })} />
                  {errors?.relationEmail?.type === "required" && <p className="error-text">This field is required</p>}
                  {errors?.relationEmail?.type === "maxLength" && <p className="error-text">Email cannot exceed 32 characters</p>}
                  {errors?.relationEmail?.type === "pattern" && <p className="error-text">Please enter valid email</p>}
                </div>

                <div className="label-input"  style={{ width: '35%' }}>
                  <label>Phone Number (User who is registering)</label>
                  <input
                    type="tel"
                    className="input-field input-border"
                    style={{ width: "95%" }}
                    id="relationPhoneNumber"
                    {...register("relationPhoneNumber", {
                      required: "Relation Phone number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter a valid 10-digit phone number"
                      }
                    })}
                  />
                  {errors?.relationPhoneNumber && <p className="error-text">{errors.relationPhoneNumber.message}</p>}
                </div>

                <div className="label-input">
                  <label>How Are You Related To This Family Member?</label>
                  <select className="input-field input-border" id="relation" {...register("relation", {
                    required: true,
                  })}>
                    <option value="">Select</option>
                    <option value="Son/Daughter">Son/Daughter</option>
                    <option value="Spouse/Partner">Spouse/Partner</option>
                    <option value="Parent">Parent</option>
                    <option value="CloseFriend">Close Friend</option>
                  </select>
                  {errors?.relation && <p className="error-text">This field is required</p>}
                </div>
              </div>

              <div className="name-fields">
                <div className="label-input">
                  <label >Create Password</label>
                  <input className="input-field input-border" type="password" {...register("password", {
                    required: true,
                    maxLength: 32,
                    minLength: 8
                  })} ></input>
                  {errors?.password?.type === "required" && <p className="error-text">This field is required</p>}
                  {errors?.password?.type === "maxLength" && <p className="error-text">Password cannot exceed 32 characters</p>}
                  {errors?.password?.type === "minLength" && <p className="error-text">Password length must be more than 8 characters</p>}
                </div>
                <div className="label-input">
                  <label >Re-type Password</label>
                  {/* <input className="input-field input-border" type="password" {...register("confirmPassword", {
                    validate: val => watch('password') === val
                  })}  ></input> */}
                   <input
                    // onKeyDown={(event) => {
                    //   if (event.key === "Enter") {
                    //     handleSubmit(onsubmit)();
                    //   }
                    // }} 
                      className="input-field input-border" type="password" {...register("confirmPassword", {
                      validate: val => watch('password') === val
                    })}  ></input>

                  {errors?.confirmPassword && <p className="error-text">Passwords must match</p>}
                </div>
              </div>

              <div className="required-fields" style={{ justifyContent: 'flex-start' }}>
                <div className="myself-label" style={{ width: "48%" }}>
                  <p>Already a youro member? <span onClick={() => navigate('/login')} className="color-secondary" style={{ cursor: 'pointer' }}><u>Login</u></span> </p>
                </div>
                <div className="myself-label" style={{ width: "45%", position: "relative" }}>
                  <button  type="submit" className="next-button btn-filled" onClick={handleSubmit((onsubmit))}>Next</button>

                </div>
              </div>
            </div>
          </form>

        </>
      }

      {step === 1 && <Patientaddress data={data} step2Data={step2Data} />}
      {step === 2 && <PrivacyPolicy data={data} uType={USER_TYPES.user} subscription={subscriptionStatus.active}/>}

    </div>
  )
}

export default SignupforFamilyMember;
